// extracted by mini-css-extract-plugin
export var infoItem = "_sa-2";
export var title = "_sa-0";
export var value = "_sa-1";